/**
 * Relationship Service
 * Migrated from 3in1cms legacy/relationshipApi.ts
 */

import { createCacheAsync } from "@repo/shared-utils/cache";
import { request } from "../core/request";
import { API_RESPONSE_CODES, DEFAULT_CONNECTION_FROM, OPERATION_IDS } from "./constants";
import type { IRelationshipResponse } from "../types/relationshipTypes";

/**
 * Get customer relationship details
 * @param mobileNumber - Customer mobile number
 * @returns Relationship response with customer details
 */
export const getRelationship = async (mobileNumber: string): Promise<IRelationshipResponse> => {
  try {
    const response = (await createCacheAsync(
      `${OPERATION_IDS.custRelationship}-${mobileNumber}`,
      async () => {
        const result = await request<IRelationshipResponse, { mobileNumber: string }>({
          operationId: OPERATION_IDS.custRelationship,
          requestData: {
            mobileNumber,
          },
          connectionFrom: DEFAULT_CONNECTION_FROM,
        });
        return result;
      }
    )) as IRelationshipResponse;
    return response;
  } catch (error) {
    console.error("Error in getRelationship", error);
    return {
      statusCode: API_RESPONSE_CODES.STATUS_CODE_7002,
      description: "Error fetching relationship data",
      custRelationshipDetails: {
        customerId: 0,
        Cards: [],
        insurance: [],
        deposits: [],
        loan: [],
        mutualFunds: false,
        creditCards: [],
      },
      custRelationshipDetailsList: [],
    };
  }
};
